import { createFileRoute } from "@tanstack/react-router";
import About from "@/pages/site/About";

export const Route = createFileRoute("/about/")({
  component: () => <About />,
});
